<div id="features-2" class=" section-2" style="background-color: white; text-align: right;background-image: url('../../../assets/img/formBack.gif'); background-size: cover"
[ngStyle]="{'direction':this.apiService.currentDirection ==='rtl'? 'rtl': 'ltr'}">
<!--  <div class="d-flex justify-content-end px-5 pt-3">-->
<!--    <a href="https://alobodo.com/" target="_blank">بازگشت</a>-->
<!--  </div>-->

  <div class="container p-5">
    <div class="formBox">


      <div class="section-header text-center px-3" style="margin-bottom: 50px;">
        <div class=" col-12 d-flex justify-content-between">
          <img src="../../../assets/img/Alobodo.png" class="banner" style="width: 90px;height: auto; margin-top: 10px"/>
          <img src="../../../assets/img/asnaf.png" class="banner" style="width: 90px;height: 90px; margin-top:10px"/>
        </div>

        <h3 class="pt-4"> {{'AlobdoTechnicianPreregistration'|translate}} </h3>

      </div>
      <!-----------------------------------------------registration-------------------------------------------------------------->
      <div >
        <div class=" row justify-content-center verticalMargin">

          <div class="col-md-5 col-12 text-center">


            <div>
              <mat-form-field class="example-full-width mx-1"
                              [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
                <label> {{'FirstName'|translate}} </label>
                <input matInput [(ngModel)]="name" id="name" [disabled]="disable"
                       [ngModelOptions]="{standalone: true}">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="example-full-width mx-1"
                              [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
                <label> {{'LastName' | translate}} </label>
                <input matInput [(ngModel)]="lastName" id="lastName" [disabled]="disable"
                       [ngModelOptions]="{standalone: true}">
              </mat-form-field>
            </div>


            <div class="position-relative">
              <mat-form-field class="example-full-width mx-1"
                              [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
                <label> {{'PhoneNum' | translate}} </label>
                <input matInput [(ngModel)]="phoneNumber" class="leftSideText" id="phoneNumber" [disabled]="disable"
                      [ngModelOptions]="{standalone: true}">

              </mat-form-field>
            </div>


          </div>

          <div class="col-md-5   col-12 verticalMargin">

            <div class='uploadCard w-75'>

              <div class="closeBtn" id="profileImageDel" (click)="deleteImage('profileImage')">
                <i class="fa fa-times fa-lg" aria-hidden="true"></i>
              </div>

              <div id='profileImageBox'>
                <label for="myInput" class="btn btn-primary btn-input custom-btn" (click)="key='profileImage';Width=3;Height=4;"> {{'UploadPersonalPhoto' | translate}} </label>
                <input id="myInput" type="file" name="file"  (change)="fileChangeEvent($event);"
                       (click)="$event.target.value=null"
                       style="visibility:hidden;display: contents"/>

<!--                <label id="profileImageFile" class="btn btn-custom btn-input"-->
<!--                       (click)="open(img, 'md');key='profileImage';Width=3;Height=4;"> آپلود عکس پرسنلی</label>-->

                <!--              <input id="profileImageFile" type="file" name="file" (change)="selectFile($event,'profileImage');"-->
                <!--                                                                                                                   (click)="$event.target.value=null" style="visibility:hidden;display: contents"/>-->
                <p class=" " style="margin-top: 20px;"> {{'MaxSize' | translate}}  : 10MB</p>
                <p class=" "> {{'FileTypes' | translate}}  : jpg, jpeg, png</p>
                <i class="fa fa-paperclip fa-2x attachment" aria-hidden="true"></i>
              </div>

              <div id="profileImageContent">


              </div>
            </div>


          </div>


        </div>

        <div class=" row justify-content-center verticalMargin">

          <div class="col-md-5 col-12 text-center" >
            <div>
              <mat-form-field class="example-full-width mx-1"
                              [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
                <label> {{'NationalId' | translate}} </label>
                <input matInput [(ngModel)]="nationalCardId" class="leftSideText" id="nationalCardId" [disabled]="disable"
                       [ngModelOptions]="{standalone: true}">
              </mat-form-field>
            </div>

            <div>
              <mat-form-field class="example-full-width mx-1"
                              [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
                <label> {{'Province' | translate}} </label>
                <mat-select [(ngModel)]="province" (ngModelChange)="getCities()"  id="province" [disabled]="disable">
                  <mat-option  value="0">------</mat-option>
                  <mat-option *ngFor="let item of provinces" [value]="item.id">{{item.name}}</mat-option>
                </mat-select>

              </mat-form-field>
            </div>

            <div>
              <mat-form-field class="example-full-width mx-1"
                              [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
                <label> {{'City' | translate}} </label>
                <mat-select [(ngModel)]="city"   id="city" [disabled]="disable">
                  <mat-option  value="0">------</mat-option>
                  <mat-option *ngFor="let item of cities" [value]="item.id">{{item.name}}</mat-option>
                </mat-select>

              </mat-form-field>
            </div>

          </div>

          <div class="col-md-5  col-12 verticalMargin">
            <div class="uploadCard w-75">

              <div class="closeBtn" id="nationalCardDel" (click)="deleteImage('nationalCard')">
                <i class="fa fa-times fa-lg" aria-hidden="true"></i>
              </div>

              <div id='nationalCardBox'>
                <!--              <label id="nationalCardFile" class="btn btn-custom btn-input" (click)="open(img, 'md');key='nationalCard';Width=1.4;Height=1"> آپلود کارت ملی</label>-->
                <label for="nationalCardFile" class="btn btn-primary btn-input custom-btn"> {{'UploadNationalCard' | translate}} </label>

                <input id="nationalCardFile" type="file" name="file" (change)="selectFile($event,'nationalCard');"
                       (click)="$event.target.value=null"
                       style="visibility:hidden;display: contents"/>
                <p class=" " style="margin-top: 20px;">  {{'MaxSize' | translate}} : 10MB</p>
                <p class=" ">  {{'FileTypes' | translate}} : jpg, jpeg, png</p>
                <i class="fa fa-paperclip  fa-2x attachment" aria-hidden="true"></i>
              </div>

              <div id="nationalCardContent">
              </div>
            </div>
          </div>


        </div>


        <div class=" row justify-content-center verticalMargin">


          <div class="col-md-5   col-12 text-center">


            <div class="form-group">
              <app-nested-select *ngIf="listData" [getListData]="listData['result']" [selectableParent]="false"
                                 (click)="getTags();this.tags=[]" [(selectedValue)]="selectValues['select1']"
                                 [searchKeyword]="selectValues['select1']">
              </app-nested-select>


            </div>






            <mat-form-field class="example-full-width mx-1"  id="tags"
                            [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl' ? 'right': 'left'}">
              <label> {{'Skills' | translate}} </label>
              <!--          <mat-select [(value)]="tags"-->
              <!--                      (selectionChange)="" multiple>-->
              <mat-select [(value)]="tags" multiple  >
                <mat-option value="0">---</mat-option>
                <mat-option *ngFor="let tag of tagsList"
                            [value]="{id:tag.id, title:tag.title}">{{tag.title}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="row" id="skills" *ngIf="isShow" >
              <span class="skillBadge" *ngFor="let item of tags">{{item.title}}</span>
            </div>


          </div>
          <div class="col-md-5   col-12 verticalMargin">

            <div class="uploadCard w-75">

              <div class="closeBtn" id="lisenceDel" (click)="deleteImage('lisence')">
                <i class="fa fa-times fa-lg" aria-hidden="true"></i>
              </div>

              <div id='lisenceBox'>
                <!--              <label id="lisenceFile" class="btn btn-custom btn-input"  (click)="open(img, 'md');key='lisence';Width=6;Height=4"> آپلود پروانه کسب</label>-->
                <label for="lisenceFile" class="btn btn-primary btn-input custom-btn" style="width: max-content"> {{'UploadBusinessLicenseOrQualificationCard' | translate }} </label>
                <input id="lisenceFile" type="file" name="file" (change)="selectFile($event,'lisence');"
                       (click)="$event.target.value=null"
                       style="visibility:hidden;display: contents"/>

                <p class=" " style="margin-top: 20px;">  {{'MaxSize' | translate}} : 10MB</p>
                <p class=" "> {{'FileTypes' | translate}}  : jpg, jpeg, png</p>
                <i class="fa fa-paperclip attachment fa-2x" aria-hidden="true"></i>
              </div>

              <div id="lisenceContent">
              </div>
            </div>


          </div>
        </div>

        <div class=" row justify-content-center col-md-12 col-12 mt-5" id="submit">

          <button class="btn btn-primary custom-btn mb-3" style="width: 140px" *ngIf="sendRequestFlag === false" (click)="sumbit();"> {{'Submit' | translate}} </button>
          <div class="mb-5 pb-3" *ngIf="sendRequestFlag=== true">
            <div class=" loader mini-loader"></div>
          </div>


        </div>
      </div>

    </div>
  </div>
</div>


<ng-template let-c="close" let-d="dismiss" #modal>
  <div class="modal-header" [dir]="this.apiService.currentDirection"
       [ngStyle]="{'background': this.apiStatus === 1 ? '#34a853': '#dc3545'}">
    <p style="color: #fff">پیغام</p>
  </div>
  <!------------------  image ---------------------------------------------->
  <div [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
    <div class="col-md-12 py-4 px-2"
         [ngStyle]="{'background': this.apiStatus === 1 ? 'rgb(171 214 183 / 62%)': '#d0b8b8a'}">

      <h5 class="text-right" [dir]="this.apiService.currentDirection">{{this.modalContext}}</h5>

    </div>
    <div class="col-12 d-flex p-2"
         [ngStyle]="{'background': this.apiStatus === 1 ? 'rgb(171 214 183 / 62%)': '#d0b8b8a'}">

      <button type="button" class="btn  btn-danger mx-1 mt-3"
              (click)="d('Cross click')">بستن
      </button>
    </div>
  </div>

</ng-template>


<ng-template let-c="close" let-d="dismiss" #img>
  <div class="modal-header" [dir]="this.apiService.currentDirection">
    <p>تصویر</p>
  </div>
  <!---------------------------add & edit---------------------------------------------------------------------------------------------------------------->
  <div class="modal-body"
       [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">

    <div class=" col-md-12 text-center">
      <!--      <input  id="myInput" type="file" (change)="fileChangeEvent($event)" />-->
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [aspectRatio]="Width / Height"
        format="png"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"
      ></image-cropper>

    </div>
    <div class="modal-footer">
      <div class="row d-flex justify-content-end">

        <!--        <button type="button" class="btn btn-outline-dark mt-2"-->
        <!--                (click)="addNewTariff()">-->
        <!--          {{'Button.Save'|translate}}-->
        <!--        </button>-->
        <button type="button" class="btn btn-custom mt-2"
                (click)="d('Cross click');">
          تایید
        </button>
      </div>


    </div>

  </div>

</ng-template>
